/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EligibilityRequestAltParamsInner
 */
export interface EligibilityRequestAltParamsInner {
    /**
     * 
     * @type {string}
     * @memberof EligibilityRequestAltParamsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EligibilityRequestAltParamsInner
     */
    value?: string;
}

/**
 * Check if a given object implements the EligibilityRequestAltParamsInner interface.
 */
export function instanceOfEligibilityRequestAltParamsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EligibilityRequestAltParamsInnerFromJSON(json: any): EligibilityRequestAltParamsInner {
    return EligibilityRequestAltParamsInnerFromJSONTyped(json, false);
}

export function EligibilityRequestAltParamsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityRequestAltParamsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function EligibilityRequestAltParamsInnerToJSON(value?: EligibilityRequestAltParamsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

